<template>
  <div class="w-full preview-popup">
    <div class="font-bold">Preview</div>

    <WeeklyCalculatedTotals :getAllRecipes="getAllRecipes" :weeklyAvg="weeklyAvg" :guideline_data="guideline_data"
      :mc_weekly_avg_prods="mc_weekly_avg_prods" :null_nutrient="null_nutrient" :override_components="override_components" />



    <div class="flex flex-nowrap pt-0 pb-10 overflow-x-auto items-start">
      <div class="w-72-box-sizing bg-white mr-4 rounded-t-lg white-shadow-box mb-4">
        <!-- <div v-if="total_planned_number_mon > 0 && mc_final_options_mon.length > 0">
                            <input type="number" class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded input-background text-center w-[65px] top-2 absolute right-[30px] h-7 min-w-min-button button-bg-color-wed" v-model="total_planned_number_mon" :disabled="true">
                        </div> -->
        <header
          class="searching-background-color flex justify-between py-2 pl-2 shadow overflow-hidden rounded-t-lg w-full">
          <div class="left_coll flex gap-2 items-center">
            <h2 class="text-white text-lg font-bold cursor-pointer w-full"
              :title="$helpers.getByName(mc_daily_sum_prod_mon)">Monday</h2>
            <div style="z-index: 1; " class="h-[20px]">

              <i v-show="showWarningHover(mc_daily_sum_prod_mon, mc_final_options_mon).length > 0 && getAllDay.includes('mon')"
                v-on:mouseover="showMonAdditional = true" v-on:mouseleave="showMonAdditional = false"
                class="fa fa-exclamation-circle bg-white rounded-full text-[#cb0000] mr-auto text-lg "
                style="font-size: 25px; line-height: 20px;" aria-hidden="true"></i>
              <ul v-if="showMonAdditional" class="absolute bg-white p-4 ml-4"
                style="border-radius: 0px 10px 10px 10px;">
                <li v-for="additional in showWarningHover(mc_daily_sum_prod_mon, mc_final_options_mon)"
                  class="block text-black text-sm list-disc pb-1">
                  {{ additional }}
                </li>
              </ul>
            </div>
          </div>
          <div v-if="total_planned_number_mon > 0 && mc_final_options_mon.length > 0" class="w-14">
            <input type="number"
              class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded input-background text-center w-[60px] top-2 absolute right-[30px] h-7 min-w-min-button button-bg-color-wed input_arrow_hidden"
              v-model="total_planned_number_mon" :disabled="true">
          </div>
        </header>
        <WeekDayTotals :guideline_data="guideline_data" :mc_daily_sum_prod="mc_daily_sum_prod_mon" />
        <div v-if="!mc_final_options_mon.length" class="w-full flex flex-wrap items-center justify-center py-2">
          <div>
            <div class="text-center pl-8">
              <img :src="$page.props.asset_url + '/vendor/nutristudents/image/food-img/_Path_.png'">
            </div>
            <p class="pt-4 pl-2">Nothing Here Yet</p>
            <a href="javascript:void(0)" v-if="menucycle.is_tenant_admin" @click="addRecipeOptionMenuCycle(1)"
              class="underline text-center block">Add A Menu Option</a>
            <button v-if="copied_option_data" type="button"
              @click="addOptionPasteScript(mc_final_options_mon.length, 1)" class="underline text-center block">Paste
              Menu Option</button>
          </div>
        </div>
        <draggable class="list-group" :list="mc_final_options_mon" draggable=".asdf"
          change="event => handleDrag(event, 1)">
          <template #item="{ element, index }">
            <div class="px-4 py-4">
              <div class="bg-hard-grey px-4 py-3 pt-4 rounded draggable-item" @mouseover="showAddIcon = true"
                @mouseleave="showAddIcon = false">
                <ul>
                  <li class="flex flex-nowrap justify-between pb-4 relative uppercase">
                    <div :title="$helpers.getByName(element.new_total_val)" class="cursor-pointer max-w-[60%]">{{
                      element.name }}
                    </div>
                    <input @change="changePlannedNumberValue(element, 'mon')" type="number"
                      v-model="element.planned_number" disabled
                      class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded input-background text-center w-[60px] top-0 absolute right-6 h-7 min-w-min-button button-bg-color-wed input_arrow_hidden"
                      autocomplete="off">
                    <!-- <input  @click="autoSelect($event)"> -->

                  </li>
                  <li v-for="(mc_option_recipe, index1) in sortedArray(element.recipes)"
                    class="flex flex-nowrap justify-between pb-4 cursor-pointer"
                    :title="$helpers.getByName(mc_option_recipe.total_val)">
                    <div class="flex gap-2 w-full justify-between "
                      mouseover="hoveredIndex = mc_option_recipe.id + element.id"
                      mouseleave="hoveredIndex = null, is_show = false" @mouseleave="is_show = false">
                      <div class="text-sm font-bold text-color-first-li">
                        <a href="javascript:void(0)">
                          {{ mc_option_recipe.name }}
                        </a>
                      </div>
                      <div>
                        <div class="text-sm flex flex-nowrap justify-end h-1.5 relative group-hover:hidden">
                          <span class="" v-if="hoveredIndex !== mc_option_recipe.id + element.id">{{
                            $helpers.getByFirstName(mc_option_recipe.total_val)
                          }}</span>
                        </div>
                        <div class="ml-auto relative hidden group-hover:block min-w-[50px]">
                          <svg xmlns="http://www.w3.org/2000/svg"
                            class="h-5 w-5 menu1-icon-color cursor-pointer ml-auto" viewBox="0 0 20 20"
                            fill="currentColor" @click="is_show = !is_show"
                            if="hoveredIndex === mc_option_recipe.id + element.id">
                            <path
                              d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                          </svg>

                          <div v-if="is_show" class="
                                                            bg-white popup-shadow py-3 absolute !right-0 !top-5 rounded-md box-border z-10 
                                                            ">
                            <ul class="w-full cursor-default">
                              <li class="px-4 text-black hover:bg-gray-200">
                                <button type="button" @click="
                                  deleteOptionRecipeButton(
                                    mc_option_recipe,
                                    element, 'mon'
                                  )
                                  ">
                                  Remove Recipe
                                </button>
                              </li>
                              <li class="px-4 text-black hover:bg-gray-200">
                                <button type="button"
                                  @click="replaceOptionRecipe(mc_option_recipe, index1, element, index, 'mon')">
                                  Replace Recipe
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>

                </ul>
              </div>
            </div>
          </template>
        </draggable>

      </div>

      <div class="w-72-box-sizing bg-white mr-4 rounded-t-lg white-shadow-box mb-4">

        <header
          class="searching-background-color flex justify-between py-2 pl-2 shadow overflow-hidden rounded-t-lg w-full">
          <div class="left_coll flex gap-2 items-center">
            <h2 class="text-white text-lg font-bold cursor-pointer  w-full"
              :title="$helpers.getByName(mc_daily_sum_prod_tue)">Tuesday</h2>

            <div class="h-[20px]" style="z-index: 1;">
              <i v-show="showWarningHover(mc_daily_sum_prod_tue, mc_final_options_tue).length > 0 && getAllDay.includes('tue')"
                v-on:mouseover="showTueAdditional = true" v-on:mouseleave="showTueAdditional = false"
                class="fa fa-exclamation-circle text-[#cb0000] mr-auto text-lg bg-white rounded-full "
                style="font-size: 25px; line-height: 20px;" aria-hidden="true"></i>
              <ul v-show="showTueAdditional" class="absolute bg-white p-4 ml-4"
                style="border-radius: 0px 10px 10px 10px;">
                <li class="block text-black text-sm list-disc pb-1"
                  v-for="additional in showWarningHover(mc_daily_sum_prod_tue, mc_final_options_tue)">
                  {{ additional }}
                </li>
              </ul>
            </div>
          </div>
          <div v-if="total_planned_number_tue > 0 && mc_final_options_tue.length > 0" class="w-14">
            <input type="number"
              class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded input-background text-center w-[60px] top-2 absolute right-[30px] h-7 min-w-min-button button-bg-color-wed input_arrow_hidden"
              v-model="total_planned_number_tue" :disabled="true">
          </div>

        </header>

        <WeekDayTotals :guideline_data="guideline_data" :mc_daily_sum_prod="mc_daily_sum_prod_tue" />




        <draggable class="list-group" :list="mc_final_options_tue" group="menus" change="event => handleDrag(event, 2)"
          draggable=".asdf">
          <template #item="{ element, index }">
            <div class="px-4 py-4">
              <div class="bg-hard-grey px-4 py-3 pt-4 rounded draggable-item">
                <ul>
                  <li class="flex flex-nowrap justify-between pb-4 relative uppercase">
                    <div :title="$helpers.getByName(element.new_total_val)" class="cursor-pointer max-w-[60%]">{{
                      element.name }}</div>
                    <input @change="changePlannedNumberValue(element, 'tue')" type="number"
                      v-model="element.planned_number" disabled
                      class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded input-background text-center w-[60px] top-0 absolute right-6 h-7 min-w-min-button button-bg-color-wed input_arrow_hidden">


                  </li>
                  <li v-for="(mc_option_recipe, index1) in sortedArray(element.recipes)"
                    class="flex flex-nowrap justify-between pb-4 cursor-pointer"
                    :title="$helpers.getByName(mc_option_recipe.total_val)">
                    <div class="flex gap-2 w-full justify-between "
                      mouseover="hoveredIndex = mc_option_recipe.id + element.id"
                      mouseleave="hoveredIndex = null, is_show = false" @mouseleave="is_show = false">
                      <div class="text-sm font-bold text-color-first-li">
                        <a href="javascript:void(0)">
                          {{ mc_option_recipe.name }}
                        </a>
                      </div>
                      <div>
                        <div class="text-sm flex flex-nowrap justify-end h-1.5 relative group-hover:hidden">
                          <span class="" v-if="hoveredIndex !== mc_option_recipe.id + element.id">{{
                            $helpers.getByFirstName(mc_option_recipe.total_val)
                          }}</span>
                        </div>
                        <div class="ml-auto relative hidden group-hover:block min-w-[50px]">
                          <svg xmlns="http://www.w3.org/2000/svg"
                            class="h-5 w-5 menu1-icon-color cursor-pointer ml-auto" viewBox="0 0 20 20"
                            fill="currentColor" @click="is_show = !is_show"
                            if="hoveredIndex === mc_option_recipe.id + element.id">
                            <path
                              d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                          </svg>

                          <div v-if="is_show" class="
                                    bg-white popup-shadow py-3 absolute !right-0 !top-5 rounded-md box-border z-10 
                                    ">
                            <ul class="w-full cursor-default">
                              <li class="px-4 text-black hover:bg-gray-200">
                                <button type="button" @click="
                                  deleteOptionRecipeButton(
                                    mc_option_recipe,
                                    element, 'tue'
                                  )
                                  ">
                                  Remove Recipe
                                </button>
                              </li>
                              <li class="px-4 text-black hover:bg-gray-200">
                                <button type="button"
                                  @click="replaceOptionRecipe(mc_option_recipe, index1, element, index, 'tue')">
                                  Replace Recipe
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                  </li>
                </ul>
              </div>
            </div>
          </template>
        </draggable>


      </div>

      <div class="w-72-box-sizing bg-white mr-4 rounded-t-lg white-shadow-box mb-4">

        <header
          class="searching-background-color flex justify-between py-2 pl-2 shadow overflow-hidden rounded-t-lg w-full">
          <div class="left_coll flex gap-2 items-center">
            <h2 class="text-white text-lg font-bold  cursor-pointer w-full"
              :title="$helpers.getByName(mc_daily_sum_prod_wed)">Wednesday</h2>
            <div class="h-[20px]" style="z-index: 1;">
              <i v-show="showWarningHover(mc_daily_sum_prod_wed, mc_final_options_wed).length > 0 && getAllDay.includes('wed')"
                v-on:mouseover="showWebAdditional = true" v-on:mouseleave="showWebAdditional = false"
                class="fa fa-exclamation-circle bg-white rounded-full text-[#cb0000] mr-auto text-lg "
                style="font-size: 25px; line-height: 20px;" aria-hidden="true"></i>
              <ul v-show="showWebAdditional" class="absolute bg-white p-4 ml-4"
                style="border-radius: 0px 10px 10px 10px;">
                <li class="block text-black text-sm list-disc pb-1"
                  v-for="additional in showWarningHover(mc_daily_sum_prod_wed, mc_final_options_wed)">
                  {{ additional }}
                </li>
              </ul>
            </div>
          </div>
          <div v-if="total_planned_number_wed > 0 && mc_final_options_wed.length > 0" class="w-14">
            <input type="number"
              class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded input-background text-center w-[60px] top-2 absolute right-[30px] h-7 min-w-min-button button-bg-color-wed input_arrow_hidden"
              v-model="total_planned_number_wed" :disabled="true">
          </div>

        </header>

        <WeekDayTotals :guideline_data="guideline_data" :mc_daily_sum_prod="mc_daily_sum_prod_wed" />



        <draggable class="list-group" :list="mc_final_options_wed" group="menus" change="event => handleDrag(event, 3)"
          draggable=".asdf">
          <template #item="{ element, index }">
            <div class="px-4 py-4">
              <div class="bg-hard-grey px-4 py-3 pt-4 rounded draggable-item">
                <ul>
                  <li class="flex flex-nowrap justify-between pb-4 relative uppercase">
                    <div :title="$helpers.getByName(element.new_total_val)" class="cursor-pointer max-w-[60%]">{{
                      element.name }}</div>
                    <input @change="changePlannedNumberValue(element, 'wed')" type="number"
                      v-model="element.planned_number" disabled
                      class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded input-background text-center w-[60px] top-0 absolute right-6 h-7 min-w-min-button button-bg-color-wed input_arrow_hidden">


                  </li>

                  <li v-for="(mc_option_recipe, index1) in sortedArray(element.recipes)"
                    class="flex flex-nowrap justify-between pb-4 cursor-pointer"
                    :title="$helpers.getByName(mc_option_recipe.total_val)">

                    <div class="flex gap-2 w-full justify-between "
                      mouseover="hoveredIndex = mc_option_recipe.id + element.id"
                      mouseleave="hoveredIndex = null, is_show = false" @mouseleave="is_show = false">
                      <div class="text-sm font-bold text-color-first-li">
                        <a href="javascript:void(0)">
                          {{ mc_option_recipe.name }}
                        </a>
                      </div>
                      <div>
                        <div class="text-sm flex flex-nowrap justify-end h-1.5 relative group-hover:hidden">
                          <span class="" v-if="hoveredIndex !== mc_option_recipe.id + element.id">{{
                            $helpers.getByFirstName(mc_option_recipe.total_val)
                          }}</span>
                        </div>
                        <div class="ml-auto relative hidden group-hover:block min-w-[50px]">
                          <svg xmlns="http://www.w3.org/2000/svg"
                            class="h-5 w-5 menu1-icon-color cursor-pointer ml-auto" viewBox="0 0 20 20"
                            fill="currentColor" @click="is_show = !is_show"
                            if="hoveredIndex === mc_option_recipe.id + element.id">
                            <path
                              d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                          </svg>

                          <div v-if="is_show" class="
                                    bg-white popup-shadow py-3 absolute !right-0 !top-5 rounded-md box-border z-10 
                                    ">
                            <ul class="w-full cursor-default">
                              <li class="px-4 text-black hover:bg-gray-200">
                                <button type="button" @click="
                                  deleteOptionRecipeButton(
                                    mc_option_recipe,
                                    element, 'wed'
                                  )
                                  ">
                                  Remove Recipe
                                </button>
                              </li>
                              <li class="px-4 text-black hover:bg-gray-200">
                                <button type="button"
                                  @click="replaceOptionRecipe(mc_option_recipe, index1, element, index, 'wed')">
                                  Replace Recipe
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                  </li>
                </ul>
              </div>
            </div>
          </template>
        </draggable>


      </div>

      <!-----------------fourth------>
      <div class="w-72-box-sizing bg-white mr-4 rounded-t-lg white-shadow-box mb-4">

        <header
          class="searching-background-color flex justify-between py-2 pl-2 shadow overflow-hidden rounded-t-lg w-full">
          <div class="left_coll flex gap-2 items-center">
            <h2 class="text-white text-lg font-bold cursor-pointer w-full"
              :title="$helpers.getByName(mc_daily_sum_prod_thu)">
              Thursday</h2>

            <div style="z-index: 1;" class="h-[20px]">
              <i v-show="showWarningHover(mc_daily_sum_prod_thu, mc_final_options_thu).length > 0 && getAllDay.includes('thu')"
                v-on:mouseover="showThuAdditional = true" v-on:mouseleave="showThuAdditional = false"
                class="fa fa-exclamation-circle bg-white rounded-full text-[#cb0000] mr-auto text-lg "
                style="font-size: 25px; line-height: 20px;" aria-hidden="true"></i>
              <ul v-show="showThuAdditional" class="absolute bg-white p-4 ml-4"
                style="border-radius: 0px 10px 10px 10px;">
                <li class="block text-black text-sm list-disc pb-1"
                  v-for="additional in showWarningHover(mc_daily_sum_prod_thu, mc_final_options_thu)">
                  {{ additional }}
                </li>
              </ul>
            </div>
          </div>
          <div v-if="total_planned_number_thu > 0 && mc_final_options_thu.length > 0" class="w-14">
            <input type="number"
              class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded input-background text-center w-[60px] top-2 absolute right-[30px] h-7 min-w-min-button button-bg-color-wed input_arrow_hidden"
              v-model="total_planned_number_thu" :disabled="true">
          </div>

        </header>

        <WeekDayTotals :guideline_data="guideline_data" :mc_daily_sum_prod="mc_daily_sum_prod_thu" />



        <draggable class="list-group" :list="mc_final_options_thu" group="menus" change="event => handleDrag(event, 4)"
          draggable=".asdf">
          <template #item="{ element, index }">
            <div class="px-4 py-4">
              <div class="bg-hard-grey px-4 py-3 pt-4 rounded draggable-item">
                <ul>
                  <li class="flex flex-nowrap justify-between pb-4 relative uppercase">
                    <div :title="$helpers.getByName(element.new_total_val)" class="cursor-pointer max-w-[60%]">{{
                      element.name }}
                      <!-- <i class="fa fa-star icon-star-color" aria-hidden="true"></i> -->
                    </div>
                    <input @change="changePlannedNumberValue(element, 'thu')" type="number"
                      v-model="element.planned_number" disabled
                      class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded input-background text-center w-[60px] top-0 absolute right-6 h-7 min-w-min-button button-bg-color-wed input_arrow_hidden">


                  </li>

                  <li v-for="(mc_option_recipe, index1) in sortedArray(element.recipes)"
                    class="flex flex-nowrap justify-between pb-4 cursor-pointer"
                    :title="$helpers.getByName(mc_option_recipe.total_val)">

                    <div class="flex gap-2 w-full justify-between "
                      mouseover="hoveredIndex = mc_option_recipe.id + element.id"
                      mouseleave="hoveredIndex = null, is_show = false" @mouseleave="is_show = false">
                      <div class="text-sm font-bold text-color-first-li">
                        <a href="javascript:void(0)">
                          {{ mc_option_recipe.name }}
                        </a>
                      </div>
                      <div>
                        <div class="text-sm flex flex-nowrap justify-end h-1.5 relative group-hover:hidden">
                          <span class="" v-if="hoveredIndex !== mc_option_recipe.id + element.id">{{
                            $helpers.getByFirstName(mc_option_recipe.total_val)
                          }}</span>
                        </div>
                        <div class="ml-auto relative hidden group-hover:block min-w-[50px]">
                          <svg xmlns="http://www.w3.org/2000/svg"
                            class="h-5 w-5 menu1-icon-color cursor-pointer ml-auto" viewBox="0 0 20 20"
                            fill="currentColor" @click="is_show = !is_show"
                            if="hoveredIndex === mc_option_recipe.id + element.id">
                            <path
                              d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                          </svg>

                          <div v-if="is_show" class="
                                    bg-white popup-shadow py-3 absolute !right-0 !top-5 rounded-md box-border z-10 
                                    ">
                            <ul class="w-full cursor-default">
                              <li class="px-4 text-black hover:bg-gray-200">
                                <button type="button" @click="
                                  deleteOptionRecipeButton(
                                    mc_option_recipe,
                                    element, 'tue'
                                  )
                                  ">
                                  Remove Recipe
                                </button>
                              </li>
                              <li class="px-4 text-black hover:bg-gray-200">
                                <button type="button"
                                  @click="replaceOptionRecipe(mc_option_recipe, index1, element, index, 'tue')">
                                  Replace Recipe
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                  </li>
                </ul>
              </div>
            </div>
          </template>
        </draggable>


      </div>
      <!--------fivth----->
      <div class="w-72-box-sizing bg-white mr-4 rounded-t-lg white-shadow-box mb-4">

        <header
          class="searching-background-color flex justify-between py-2 pl-2 shadow overflow-hidden rounded-t-lg w-full">
          <div class="left_coll flex gap-2 items-center">
            <h2 class="text-white text-lg font-bold cursor-pointer  w-full"
              :title="$helpers.getByName(mc_daily_sum_prod_fri)">Friday</h2>

            <div class="h-[20px]" style="z-index: 1;">
              <i v-show="showWarningHover(mc_daily_sum_prod_fri, mc_final_options_fri).length > 0 && getAllDay.includes('fri')"
                v-on:mouseover="showFriAdditional = true" v-on:mouseleave="showFriAdditional = false"
                class="fa fa-exclamation-circle bg-white rounded-full text-[#cb0000] mr-auto text-lg "
                style="font-size: 25px; line-height: 20px;" aria-hidden="true"></i>
              <ul v-show="showFriAdditional" class="absolute bg-white p-4 ml-4"
                style="border-radius: 0px 10px 10px 10px;">
                <li class="block text-black text-sm list-disc pb-1"
                  v-for="additional in showWarningHover(mc_daily_sum_prod_fri, mc_final_options_fri)">
                  {{ additional }}
                </li>
              </ul>
            </div>
          </div>
          <div v-if="total_planned_number_fri > 0 && mc_final_options_fri.length > 0" class="w-14">
            <input type="number"
              class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded input-background text-center w-[60px] top-2 absolute right-[30px] h-7 min-w-min-button button-bg-color-wed input_arrow_hidden"
              v-model="total_planned_number_fri" :disabled="true">
          </div>

        </header>

        <WeekDayTotals :guideline_data="guideline_data" :mc_daily_sum_prod="mc_daily_sum_prod_fri" />




        <draggable class="list-group" :list="mc_final_options_fri" group="menus" change="event => handleDrag(event, 5)"
          draggable=".asdf">
          <template #item="{ element, index }">
            <div class="px-4 py-4">
              <div class="bg-hard-grey px-4 py-3 pt-4 rounded draggable-item">
                <ul>
                  <li class="flex flex-nowrap justify-between pb-4 relative uppercase">
                    <div :title="$helpers.getByName(element.new_total_val)" class="cursor-pointer max-w-[60%]">{{
                      element.name }}
                      <!-- <i class="fa fa-star icon-star-color" aria-hidden="true"></i> -->
                    </div>
                    <input @change="changePlannedNumberValue(element, 'fri')" type="number"
                      v-model="element.planned_number" disabled
                      class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded input-background text-center w-[60px] top-0 absolute right-6 h-7 min-w-min-button button-bg-color-wed input_arrow_hidden">


                  </li>
                  <li v-for="(mc_option_recipe, index1) in sortedArray(element.recipes)"
                    class="flex flex-nowrap justify-between pb-4 cursor-pointer"
                    :title="$helpers.getByName(mc_option_recipe.total_val)">
                    <div class="flex gap-2 w-full justify-between "
                      mouseover="hoveredIndex = mc_option_recipe.id + element.id"
                      mouseleave="hoveredIndex = null, is_show = false" @mouseleave="is_show = false">
                      <div class="text-sm font-bold text-color-first-li">
                        <a href="javascript:void(0)">
                          {{ mc_option_recipe.name }}
                        </a>
                      </div>
                      <div>
                        <div class="text-sm flex flex-nowrap justify-end h-1.5 relative group-hover:hidden">
                          <span class="" v-if="hoveredIndex !== mc_option_recipe.id + element.id">{{
                            $helpers.getByFirstName(mc_option_recipe.total_val)
                          }}</span>
                        </div>
                        <div class="ml-auto relative hidden group-hover:block min-w-[50px]">
                          <svg xmlns="http://www.w3.org/2000/svg"
                            class="h-5 w-5 menu1-icon-color cursor-pointer ml-auto" viewBox="0 0 20 20"
                            fill="currentColor" @click="is_show = !is_show"
                            if="hoveredIndex === mc_option_recipe.id + element.id">
                            <path
                              d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                          </svg>

                          <div v-if="is_show" class="
                                    bg-white popup-shadow py-3 absolute !right-0 !top-5 rounded-md box-border z-10 
                                    ">
                            <ul class="w-full cursor-default">
                              <li class="px-4 text-black hover:bg-gray-200">
                                <button type="button" @click="
                                  deleteOptionRecipeButton(
                                    mc_option_recipe,
                                    element, 'fri'
                                  )
                                  ">
                                  Remove Recipe
                                </button>
                              </li>
                              <li class="px-4 text-black hover:bg-gray-200">
                                <button type="button"
                                  @click="replaceOptionRecipe(mc_option_recipe, index1, element, index, 'fri')">
                                  Replace Recipe
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </template>
        </draggable>

      </div>
      <!------------------six----------->
      <div class="w-72-box-sizing bg-white mr-4 rounded-t-lg white-shadow-box mb-4">

        <header
          class="searching-background-color flex justify-between py-2 pl-2 shadow overflow-hidden rounded-t-lg w-full">
          <div class="left_coll flex gap-2 items-center">
            <h2 class="text-white text-lg font-bold  cursor-pointer w-full"
              :title="$helpers.getByName(mc_daily_sum_prod_sat)">Saturday</h2>
            <div class="h-[20px]" style="z-index: 1;">
              <i v-show="showWarningHover(mc_daily_sum_prod_sat, mc_final_options_sat).length > 0 && getAllDay.includes('sat')"
                v-on:mouseover="showSatAdditional = true" v-on:mouseleave="showSatAdditional = false"
                class="fa fa-exclamation-circle bg-white rounded-full text-[#cb0000] mr-auto text-lg "
                style="font-size: 25px; line-height: 20px;" aria-hidden="true"></i>
              <ul v-show="showSatAdditional" class="absolute bg-white p-4 ml-4"
                style="border-radius: 0px 10px 10px 10px;">
                <li v-for="additional in showWarningHover(mc_daily_sum_prod_sat, mc_final_options_sat)"
                  class="block text-black text-sm list-disc pb-1">
                  {{ additional }}
                </li>
              </ul>
            </div>
          </div>
          <div v-if="total_planned_number_sat > 0 && mc_final_options_sat.length > 0" class="w-14">
            <input type="number"
              class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded input-background text-center w-[60px] top-2 absolute right-[30px] h-7 min-w-min-button button-bg-color-wed input_arrow_hidden"
              v-model="total_planned_number_sat" :disabled="true">
          </div>

        </header>

        <WeekDayTotals :guideline_data="guideline_data" :mc_daily_sum_prod="mc_daily_sum_prod_sat" />



        <draggable class="list-group" :list="mc_final_options_sat" group="menus" change="event => handleDrag(event, 6)"
          draggable=".asdf">
          <template #item="{ element, index }">
            <div class="px-4 py-4">
              <div class="bg-hard-grey px-4 py-3 pt-4 rounded draggable-item">
                <ul>
                  <li class="flex flex-nowrap justify-between pb-4 relative uppercase">
                    <div :title="$helpers.getByName(element.new_total_val)" class="cursor-pointer max-w-[60%]">{{
                      element.name }}
                      <!-- <i class="fa fa-star icon-star-color" aria-hidden="true"></i> -->
                    </div>
                    <input @change="changePlannedNumberValue(element, 'sat')" type="number"
                      v-model="element.planned_number" disabled
                      class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded input-background text-center w-[60px] top-0 absolute right-6 h-7 min-w-min-button button-bg-color-wed input_arrow_hidden">


                  </li>
                  <li v-for="(mc_option_recipe, index1) in sortedArray(element.recipes)"
                    class="flex flex-nowrap justify-between pb-4 cursor-pointer"
                    :title="$helpers.getByName(mc_option_recipe.total_val)">

                    <div class="flex gap-2 w-full justify-between "
                      mouseover="hoveredIndex = mc_option_recipe.id + element.id"
                      mouseleave="hoveredIndex = null, is_show = false" @mouseleave="is_show = false">
                      <div class="text-sm font-bold text-color-first-li">
                        <a href="javascript:void(0)">
                          {{ mc_option_recipe.name }}
                        </a>
                      </div>
                      <div>
                        <div class="text-sm flex flex-nowrap justify-end h-1.5 relative group-hover:hidden">
                          <span class="" v-if="hoveredIndex !== mc_option_recipe.id + element.id">{{
                            $helpers.getByFirstName(mc_option_recipe.total_val)
                          }}</span>
                        </div>
                        <div class="ml-auto relative hidden group-hover:block min-w-[50px]">
                          <svg xmlns="http://www.w3.org/2000/svg"
                            class="h-5 w-5 menu1-icon-color cursor-pointer ml-auto" viewBox="0 0 20 20"
                            fill="currentColor" @click="is_show = !is_show"
                            if="hoveredIndex === mc_option_recipe.id + element.id">
                            <path
                              d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                          </svg>

                          <div v-if="is_show" class="
                                    bg-white popup-shadow py-3 absolute !right-0 !top-5 rounded-md box-border z-10 
                                    ">
                            <ul class="w-full cursor-default">
                              <li class="px-4 text-black hover:bg-gray-200">
                                <button type="button" @click="
                                  deleteOptionRecipeButton(
                                    mc_option_recipe,
                                    element, 'sat'
                                  )
                                  ">
                                  Remove Recipe
                                </button>
                              </li>
                              <li class="px-4 text-black hover:bg-gray-200">
                                <button type="button"
                                  @click="replaceOptionRecipe(mc_option_recipe, index1, element, index, 'sat')">
                                  Replace Recipe
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                  </li>
                </ul>
              </div>
            </div>
          </template>
        </draggable>


      </div>
      <!--------seven------->
      <div class="w-72-box-sizing bg-white mr-4 rounded-t-lg white-shadow-box mb-4">

        <header
          class="searching-background-color flex justify-between py-2 pl-2 shadow overflow-hidden rounded-t-lg w-full">
          <div class="left_coll flex gap-2 items-center">
            <h2 class="text-white text-lg font-bold cursor-pointer w-full"
              :title="$helpers.getByName(mc_daily_sum_prod_sun)">
              Sunday</h2>
            <div style="z-index: 1;" class="h-[20px]">
              <i v-show="showWarningHover(mc_daily_sum_prod_sun, mc_final_options_sun).length > 0 && getAllDay.includes('sun')"
                class="fa fa-exclamation-circle bg-white rounded-full text-[#cb0000] mr-auto text-lg "
                v-on:mouseover="showSunAdditional = true" v-on:mouseleave="showSunAdditional = false"
                style="font-size: 25px; line-height: 20px;" aria-hidden="true"></i>
              <ul v-show="showSunAdditional" class="absolute bg-white p-4 ml-4"
                style="border-radius: 0px 10px 10px 10px;">
                <li v-for="additional in showWarningHover(mc_daily_sum_prod_sun, mc_final_options_sun)"
                  class="block text-black text-sm list-disc pb-1">
                  {{ additional }}
                </li>
              </ul>
            </div>
          </div>
          <div v-if="total_planned_number_sun > 0 && mc_final_options_sun.length > 0" class="w-14">
            <input type="number"
              class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded input-background text-center w-[60px] top-2 absolute right-[30px] h-7 min-w-min-button button-bg-color-wed input_arrow_hidden"
              v-model="total_planned_number_sun" :disabled="true">
          </div>

        </header>

        <WeekDayTotals :guideline_data="guideline_data" :mc_daily_sum_prod="mc_daily_sum_prod_sun" />




        <draggable class="list-group" :list="mc_final_options_sun" group="menus" change="event => handleDrag(event, 7)"
          draggable=".asdf">
          <template #item="{ element, index }">
            <div class="px-4 py-4">
              <div class="bg-hard-grey px-4 py-3 pt-4 rounded draggable-item">
                <ul>
                  <li class="flex flex-nowrap justify-between pb-4 relative uppercase">
                    <div :title="$helpers.getByName(element.new_total_val)" class="cursor-pointer max-w-[60%]">{{
                      element.name }}
                      <!-- <i class="fa fa-star icon-star-color" aria-hidden="true"></i> -->
                    </div>
                    <input @change="changePlannedNumberValue(element, 'sun')" type="number"
                      v-model="element.planned_number" disabled
                      class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded input-background text-center w-[60px] top-0 absolute right-6 h-7 min-w-min-button button-bg-color-wed input_arrow_hidden">

                  </li>

                  <li v-for="(mc_option_recipe, index1) in sortedArray(element.recipes)"
                    class="flex flex-nowrap justify-between pb-4 cursor-pointer"
                    :title="$helpers.getByName(mc_option_recipe.total_val)">

                    <div class="flex gap-2 w-full justify-between "
                      mouseover="hoveredIndex = mc_option_recipe.id + element.id"
                      mouseleave="hoveredIndex = null, is_show = false" @mouseleave="is_show = false">
                      <div class="text-sm font-bold text-color-first-li">
                        <a href="javascript:void(0)">
                          {{ mc_option_recipe.name }}
                        </a>
                      </div>
                      <div>
                        <div class="text-sm flex flex-nowrap justify-end h-1.5 relative group-hover:hidden">
                          <span class="" v-if="hoveredIndex !== mc_option_recipe.id + element.id">{{
                            $helpers.getByFirstName(mc_option_recipe.total_val)
                          }}</span>
                        </div>
                        <div class="ml-auto relative hidden group-hover:block min-w-[50px]">
                          <svg xmlns="http://www.w3.org/2000/svg"
                            class="h-5 w-5 menu1-icon-color cursor-pointer ml-auto" viewBox="0 0 20 20"
                            fill="currentColor" @click="is_show = !is_show"
                            if="hoveredIndex === mc_option_recipe.id + element.id">
                            <path
                              d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                          </svg>

                          <div v-if="is_show" class="
                                    bg-white popup-shadow py-3 absolute !right-0 !top-5 rounded-md box-border z-10 
                                    ">
                            <ul class="w-full cursor-default">
                              <li class="px-4 text-black hover:bg-gray-200">
                                <button type="button" @click="
                                  deleteOptionRecipeButton(
                                    mc_option_recipe,
                                    element, 'sun'
                                  )
                                  ">
                                  Remove Recipe
                                </button>
                              </li>
                              <li class="px-4 text-black hover:bg-gray-200">
                                <button type="button"
                                  @click="replaceOptionRecipe(mc_option_recipe, index1, element, index, 'sun')">
                                  Replace Recipe
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                  </li>
                </ul>
              </div>
            </div>
          </template>
        </draggable>

      </div>
    </div>

  </div>
</template>

<script>
import WeekCycleDayList from "@/Pages/WeekCycles/WeekCycleDayList";
import WeekCyclesOptionTotals from "@/Pages/WeekCycles/WeekCyclesOptionTotals";
import { Inertia } from "@inertiajs/inertia";
import vClickOutside from "click-outside-vue3";
var moment = require('moment');
import WeekDayTotals from "@/Pages/MenuCycle/WeekDayTotals";
import draggable from "vuedraggable";
import WeeklyCalculatedTotals from "@/Pages/MenuCycle/WeeklyCalculatedTotals";

export default {
  props: [
    'recipe',
    'mc_weekly_avg_prods1',
    'guideline_data',
    'mc_final_options_mon1',
    'mc_daily_sum_prod_mon1',
    'mc_final_options_tue1',
    'mc_daily_sum_prod_tue1',
    'mc_final_options_wed1',
    'mc_daily_sum_prod_wed1',
    'mc_final_options_thu1',
    'mc_daily_sum_prod_thu1',
    'mc_final_options_fri1',
    'mc_daily_sum_prod_fri1',
    'mc_final_options_sat1',
    'mc_daily_sum_prod_sat1',
    'mc_final_options_sun1',
    'mc_daily_sum_prod_sun1',
    // 'getAllDay',
    'menucycle',
    'days_data',
    'form',
    'optionReplaceArray',
    'searchRecipe',
    'is_whole_week',
    'myname1',
    'null_nutrient',
    'override_components'
  ],
  directives: {
    clickOutside: vClickOutside.directive,
  },

  components: {
    WeekCycleDayList,
    WeekCyclesOptionTotals,
    WeekDayTotals,
    draggable,
    WeeklyCalculatedTotals
  },
  name: "large-modal",
  data() {
    return {

      isVisible: this.optionReplacePopup,
      title: 'Option Replace Popup',
      optionSearchRecipeName: '',
      searchRecipe: null,
      showSearchBoxCancel: false,
      debounce: null,
      searched_recipes: [],
      attached_recipe_object: [],
      is_whole_week: false,
      deleted_mc_option_ids: [],
      deleted_option_component_ids: [],
      showMonAdditional: false,
      showTueAdditional: false,
      showWebAdditional: false,
      showThuAdditional: false,
      showFriAdditional: false,
      showSatAdditional: false,
      showSunAdditional: false,
      selectedRecipe: null,
      // optionReplaceArray: null,
      optionReplacePopup: false,
      datas: [{
        name: 'MMA',
        type: 'component',
        min: 'daily_min_usda_componenent_serving_meat',
        max: 'daily_max_usda_componenent_serving_meat'
      },
      {
        name: 'WGR',
        type: 'component',
        min: 'daily_min_usda_componenent_serving_grain',
        max: 'daily_max_usda_componenent_serving_grain'
      },
      {
        name: 'FRU',
        type: 'component',
        min: 'daily_min_usda_componenent_serving_fruit',
        max: 'daily_max_usda_componenent_serving_fruit'
      },
      {
        name: 'MLK',
        type: 'component',
        min: 'daily_min_usda_componenent_serving_milk',
        max: 'daily_max_usda_componenent_serving_milk'
      },
      {
        name: 'VEG',
        type: 'component',
        min: 'daily_min_usda_componenent_serving_veg',
        max: 'daily_max_usda_componenent_serving_veg'
      },
      {
        name: 'DG',
        type: 'component',
        min: 'daily_min_usda_componenent_serving_veggrn',
        max: 'daily_max_usda_componenent_serving_veggrn'
      },
      {
        name: 'RO',
        type: 'component',
        min: 'daily_min_usda_componenent_serving_vegred',
        max: 'daily_max_usda_componenent_serving_vegred'
      },
      {
        name: 'BPL',
        type: 'component',
        min: 'daily_min_usda_componenent_serving_vegleg',
        max: 'daily_max_usda_componenent_serving_vegleg'
      },

      {
        name: 'STAR',
        type: 'component',
        min: 'daily_min_usda_componenent_serving_vegstar',
        max: 'daily_max_usda_componenent_serving_vegstar'
      },
      {
        name: 'OTH',
        type: 'component',
        min: 'daily_min_usda_componenent_serving_vegothr',
        max: 'daily_max_usda_componenent_serving_vegothr'
      },
      {
        name: 'CALS',
        type: '',
        min: 'daily_min_nutrition_facts_calories',
        max: 'daily_max_nutrition_facts_calories'
      },
      {
        name: 'SOD',
        type: '',
        min: 'daily_min_nutrition_facts_sodium',
        max: 'daily_max_nutrition_facts_sodium'
      },
      {
        name: 'FAT',
        type: '',
        min: 'daily_min_nutrition_facts_totalfat',
        max: 'daily_max_nutrition_facts_totalfat'
      },
      {
        name: 'PROT',
        type: '',
        min: 'daily_min_nutrition_facts_protein',
        max: 'daily_max_nutrition_facts_protein'
      },
      {
        name: 'CARB',
        type: '',
        min: 'daily_min_nutrition_facts_carbs',
        max: 'daily_max_nutrition_facts_carbs'
      },

      {
        name: 'calfat',
        type: '',
        min: 'daily_min_nutrition_facts_calfat',
        max: 'daily_max_nutrition_facts_calfat',
        unit: ''
      },

      {
        name: 'satfat',
        type: '',
        min: 'daily_min_nutrition_facts_satfat',
        max: 'daily_max_nutrition_facts_satfat',
        unit: ''
      },

      {
        name: 'transfat',
        type: '',
        min: 'daily_min_nutrition_facts_transfat',
        max: 'daily_max_nutrition_facts_transfat',
        unit: ''
      },

      {
        name: 'polysatfat',
        type: '',
        min: 'daily_min_nutrition_facts_polysatfat',
        max: 'daily_max_nutrition_facts_polysatfat',
        unit: ''
      },
      {
        name: 'monosatfat',
        type: '',
        min: 'daily_min_nutrition_facts_monosatfat',
        max: 'daily_max_nutrition_facts_monosatfat',
        unit: ''
      },
      {
        name: 'cholesterol',
        type: '',
        min: 'daily_min_nutrition_facts_cholesterol',
        max: 'daily_max_nutrition_facts_cholesterol',
        unit: ''
      },
      {
        name: 'potassium',
        type: '',
        min: 'daily_min_nutrition_facts_potassium',
        max: 'daily_max_nutrition_facts_potassium',
        unit: 'mg'
      },
      {
        name: 'fiber',
        type: '',
        min: 'daily_min_nutrition_facts_fiber',
        max: 'daily_max_nutrition_facts_fiber',
        unit: 'g'
      },
      {
        name: 'sugar',
        type: '',
        min: 'daily_min_nutrition_facts_sugar',
        max: 'daily_max_nutrition_facts_sugar',
        unit: 'g'
      },
      {
        name: 'vitamina',
        type: '',
        min: 'daily_min_nutrition_facts_vitamina',
        max: 'daily_max_nutrition_facts_vitamina',
        unit: 'mcg RAE'
      },
      {
        name: 'vitaminb6',
        type: '',
        min: 'daily_min_nutrition_facts_vitaminb6',
        max: 'daily_max_nutrition_facts_vitaminb6',
        unit: 'mg'
      },
      {
        name: 'vitaminb12',
        type: '',
        min: 'daily_min_nutrition_facts_vitaminb12',
        max: 'daily_max_nutrition_facts_vitaminb12',
        unit: 'mcg '
      },
      {
        name: 'vitaminc',
        type: '',
        min: 'daily_min_nutrition_facts_vitaminc',
        max: 'daily_max_nutrition_facts_vitaminc',
        unit: 'mg'
      },
      {
        name: 'vitamind',
        type: '',
        min: 'daily_min_nutrition_facts_vitamind',
        max: 'daily_max_nutrition_facts_vitamind',
        unit: '%'
      },
      {
        name: 'vitamine',
        type: '',
        min: 'daily_min_nutrition_facts_vitamine',
        max: 'daily_max_nutrition_facts_vitamine',
        unit: 'mcg'
      },
      {
        name: 'calcium',
        type: '',
        min: 'daily_min_nutrition_facts_calcium',
        max: 'daily_max_nutrition_facts_calcium',
        unit: 'mg'
      },
      {
        name: 'iron',
        type: '',
        min: 'daily_min_nutrition_facts_iron',
        max: 'daily_max_nutrition_facts_iron',
        unit: 'mg'
      },
      {
        name: 'magnesium',
        type: '',
        min: 'daily_min_nutrition_facts_magnesium',
        max: 'daily_max_nutrition_facts_magnesium',
        unit: 'mg'
      },
      {
        name: 'coblamin',
        type: '',
        min: 'daily_min_nutrition_facts_coblamin',
        max: 'daily_max_nutrition_facts_coblamin',
        unit: 'mg'
      },
      {
        name: 'thiamin',
        type: '',
        min: 'daily_min_nutrition_facts_thiamin',
        max: 'daily_max_nutrition_facts_thiamin',
        unit: 'mg'
      },
      {
        name: 'riboflavin',
        type: '',
        min: 'daily_min_nutrition_facts_riboflavin',
        max: 'daily_max_nutrition_facts_riboflavin',
        unit: 'mg'
      },
      {
        name: 'niacin',
        type: '',
        min: 'daily_min_nutrition_facts_niacin',
        max: 'daily_max_nutrition_facts_niacin',
        unit: 'mg'
      },
      {
        name: 'zinc',
        type: '',
        min: 'daily_min_nutrition_facts_zinc',
        max: 'daily_max_nutrition_facts_zinc',
        unit: 'mg'
      },
      {
        name: 'water',
        type: '',
        min: 'daily_min_nutrition_facts_water',
        max: 'daily_max_nutrition_facts_water',
        unit: 'g'
      },
      {
        name: 'ash',
        type: '',
        min: 'daily_min_nutrition_facts_ash',
        max: 'daily_max_nutrition_facts_ash',
        unit: 'g'
      },
      {
        name: 'added_sugars',
        type: '',
        min: 'daily_min_nutrition_facts_added_sugars',
        max: 'daily_max_nutrition_facts_added_sugars',
        unit: 'g'
      }
      ],

      todal_days: 0,

      changeMonthYearModal: false,
      guidelines: this.guidelines_val,
      name: '',
      hoveredIndex: null,
      showAddIcon: false,
      is_show: '',

      mc_final_options_mon: this.mc_final_options_mon1,
      mc_final_options_tue: this.mc_final_options_tue1,
      mc_final_options_wed: this.mc_final_options_wed1,
      mc_final_options_thu: this.mc_final_options_thu1,
      mc_final_options_fri: this.mc_final_options_fri1,
      mc_final_options_sat: this.mc_final_options_sat1,
      mc_final_options_sun: this.mc_final_options_sun1,

      mc_recipes_mon: [],
      mc_recipes_tue: [],
      mc_recipes_wed: [],
      mc_recipes_thu: [],
      mc_recipes_fri: [],
      mc_recipes_sat: [],
      mc_recipes_sun: [],

      mc_recipe_prefer_prod_mon: [],
      mc_recipe_prefer_prod_tue: [],
      mc_recipe_prefer_prod_wed: [],
      mc_recipe_prefer_prod_thu: [],
      mc_recipe_prefer_prod_fri: [],
      mc_recipe_prefer_prod_sat: [],
      mc_recipe_prefer_prod_sun: [],

      mc_daily_sum_prod_mon: this.mc_daily_sum_prod_mon1,
      mc_daily_sum_prod_tue: this.mc_daily_sum_prod_tue1,
      mc_daily_sum_prod_wed: this.mc_daily_sum_prod_wed1,
      mc_daily_sum_prod_thu: this.mc_daily_sum_prod_thu1,
      mc_daily_sum_prod_fri: this.mc_daily_sum_prod_fri1,
      mc_daily_sum_prod_sat: this.mc_daily_sum_prod_sat1,
      mc_daily_sum_prod_sun: this.mc_daily_sum_prod_sun1,

      mc_daily_sum_prod_mon_all_data: [],
      mc_daily_sum_prod_tue_all_data: [],
      mc_daily_sum_prod_wed_all_data: [],
      mc_daily_sum_prod_thu_all_data: [],
      mc_daily_sum_prod_fri_all_data: [],
      mc_daily_sum_prod_sat_all_data: [],
      mc_daily_sum_prod_sun_all_data: [],

      mc_weekly_avg_prods: this.mc_weekly_avg_prods1,

      day_number: 0,
      option_number: 0,
      editOptionData: [],
      plannedNumber: 1,

      addRecipesOptionModal: false,

      copied_option_data: '',

      sum_products_daily: [],
      avg_products_weekly: [],
      avg_products_weekly_all_data: [
        [],
        [],
        [],
        [],
        [],
        [],
        []
      ],

      formNew: this.$inertia.form({
        'uuid': '',
        'mc_id': '',
        'mc_name': '',
        'meal_type_id': '',
        'age_grade_id': '',
        'days_id': '',
        'guideline_id': ''
      }),

      form: this.$inertia.form({
        mc_id: this.menucycle.id,
        mc_name: this.menucycle.name,
        week_number: this.week_number,
        meal_type_id: this.menucycle.meal_type_id,
        age_grade_id: this.menucycle.age_grade_id,
        days_id: this.menucycle.days_id,
        guideline_id: this.menucycle.guideline_id,
        offering_id: this.offering_id,
        month: this.month,
        year: this.year,
        mealtype: this.selected_mealtype,
        agerange: this.selected_agerange,
        days: this.selected_days,
        type: this.type,

        mc_options_mon: [],
        mc_options_tue: [],
        mc_options_wed: [],
        mc_options_thu: [],
        mc_options_fri: [],
        mc_options_sat: [],
        mc_options_sun: [],
        site: this.site,
        guide_line_id: this.guide_line_id,
        mc_name_new: '',
        is_template: 0,
        is_update: this.is_update,
        daysWeek: this.daysWeek,
        menuUserWeek: this.menuUserWeek,
        mealtypeWeek: this.mealtypeWeek,
        agerangeWeek: this.agerangeWeek

      }),

      total_planned_number_mon: 0,
      total_planned_number_tue: 0,
      total_planned_number_wed: 0,
      total_planned_number_thu: 0,
      total_planned_number_fri: 0,
      total_planned_number_sat: 0,
      total_planned_number_sun: 0,
      moment: moment
    };
  },
  mounted() {
    this.changeDays();

    setTimeout(() => {
      this.totalPlannedNumber('mon');
      this.totalPlannedNumber('tue');
      this.totalPlannedNumber('wed');
      this.totalPlannedNumber('thu');
      this.totalPlannedNumber('fri');
      this.totalPlannedNumber('sat');
      this.totalPlannedNumber('sun');
    }, 1000);


  },

  computed: {
    getAllDay() {
      let days = [];
      if (this.form.days_id) {
        const dayData = this.days_data.find(day => day.id === this.form.days_id);
        if (dayData) {
          const allDays = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
          days = allDays.filter(day => dayData[day]);
        }
      }
      // console.log("getAllDay", days);
      return days;
    },
    getAllRecipes() {
      let allRecipes = [];
      if (this.mc_final_options_mon.length > 0) {
        allRecipes = allRecipes.concat(this.mc_final_options_mon);
      }
      if (this.mc_final_options_tue.length > 0) {
        allRecipes = allRecipes.concat(this.mc_final_options_tue);
      }
      if (this.mc_final_options_wed.length > 0) {
        allRecipes = allRecipes.concat(this.mc_final_options_wed);
      }
      if (this.mc_final_options_thu.length > 0) {
        allRecipes = allRecipes.concat(this.mc_final_options_thu);
      }
      if (this.mc_final_options_fri.length > 0) {
        allRecipes = allRecipes.concat(this.mc_final_options_fri);
      }
      if (this.mc_final_options_sat.length > 0) {
        allRecipes = allRecipes.concat(this.mc_final_options_sat);
      }
      if (this.mc_final_options_sun.length > 0) {
        allRecipes = allRecipes.concat(this.mc_final_options_sun);
      }
      return allRecipes;
    },
    // a computed getter
    weeklyAvg: function () {
      // `this` points to the vm instance
      let totalWeekDays = [];
      if (this.mc_daily_sum_prod_mon != null && Object.entries(this.mc_daily_sum_prod_mon).length > 0) {
        totalWeekDays.push(this.mc_daily_sum_prod_mon);
      }

      if (this.mc_daily_sum_prod_tue != null && Object.entries(this.mc_daily_sum_prod_tue).length > 0) {
        totalWeekDays.push(this.mc_daily_sum_prod_tue);
      }

      if (this.mc_daily_sum_prod_wed != null && Object.entries(this.mc_daily_sum_prod_wed).length > 0) {
        totalWeekDays.push(this.mc_daily_sum_prod_wed);
      }
      if (this.mc_daily_sum_prod_thu != null && Object.entries(this.mc_daily_sum_prod_thu).length > 0) {
        totalWeekDays.push(this.mc_daily_sum_prod_thu);
      }
      if (this.mc_daily_sum_prod_fri != null && Object.entries(this.mc_daily_sum_prod_fri).length > 0) {
        totalWeekDays.push(this.mc_daily_sum_prod_fri);
      }
      if (this.mc_daily_sum_prod_sat != null && Object.entries(this.mc_daily_sum_prod_sat).length > 0) {
        totalWeekDays.push(this.mc_daily_sum_prod_sat);
      }
      return this.$helpers.getWeeklyAvgWithBplBase(totalWeekDays, [this.mc_final_options_mon, this.mc_final_options_tue, this.mc_final_options_wed, this.mc_final_options_thu, this.mc_final_options_fri, this.mc_final_options_sat, this.mc_final_options_sun], this.todal_days, this.$page.props.serve_logic);
    }
  },
  methods: {

    // autoSelect(event) {
    //     event.target.select();
    // },

    // autoSelectInputOnClick(event) {
    //   if (event.target.tagName.toLowerCase() === 'input') {
    //     event.target.select();
    //   }
    // },

    changePlannedNumberValue(element, day) {
      element.planned_number = Math.abs(element.planned_number);
      if (element.planned_number < 0) {
        element.planned_number = 1;
      }
      this.totalPlannedNumber(day);
    },

    totalPlannedNumber(day) {
      const nutirtionsValuesGet = this.$helpers.getNutritionKeys();
      const dayOptions = this[`mc_final_options_${day}`];
      // console.log("before dayOptions", dayOptions);

      if (dayOptions.length > 0) {
        // console.log('before calculation dayOptions', dayOptions);
        let totalLength = 1;
        totalLength = dayOptions.reduce((total, option) => total + option.planned_number, 0);
        this[`total_planned_number_${day}`] = totalLength;
        // console.log("after add new total values dayOptionsday", dayOptions);

        dayOptions.forEach((option, index) => {
          let optionPlannedNumber = option.planned_number;
          let optionPercentage = (optionPlannedNumber / totalLength) * 100;
          if (option.recipes.length > 0) {
            // let total_val = {};
            // total_val = this.$helpers.getRecipeTotal(option.recipes, this.$page.props.serve_logic);
            // console.log("total_val-total_val", total_val);

            // option.new_total_val = total_val;
            // option.total_val = total_val;

            option.new_total_val = this.$helpers.getRecipeTotal(option.recipes, this.$page.props.serve_logic);
            option.total_val = this.$helpers.getRecipeTotal(option.recipes, this.$page.props.serve_logic);

            for (const key in option.total_val) {
              if (nutirtionsValuesGet.includes(key)) {
                option.total_val[key] = (option.total_val[key] * optionPercentage) / 100;
              }
            }
          }
        });
      }
      // console.log('dayOptions-dayOptions', dayOptions);
      // console.log('mc_daily_sum_prod_', this[`mc_daily_sum_prod_${day}`]);

      this[`mc_daily_sum_prod_${day}`] = this.$helpers.getDayMinimumeValue(this[`mc_final_options_${day}`]);

    },






    //   getDayName(day) {
    //     const days = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
    //     return days[day - 1];
    //   },

    handleDrag(event, day) {
      // if (day == 1) {
      //   this.sortArrays(this.mc_final_options_mon);
      //   // this.mc_daily_sum_prod_mon = this.$helpers.getDayMinimumeValue(this.mc_final_options_mon);
      //   this.totalPlannedNumber('mon');
      // } else if (day == 2) {
      //   this.sortArrays(this.mc_final_options_tue);
      //   // this.mc_daily_sum_prod_tue = this.$helpers.getDayMinimumeValue(this.mc_final_options_tue);
      //   this.totalPlannedNumber('tue');
      // } else if (day == 3) {
      //   this.sortArrays(this.mc_final_options_wed);
      //   // this.mc_daily_sum_prod_wed= this.$helpers.getDayMinimumeValue(this.mc_final_options_wed);
      //   this.totalPlannedNumber('wed');
      // } else if (day == 4) {
      //   this.sortArrays(this.mc_final_options_thu);
      //   // this.mc_daily_sum_prod_thu = this.$helpers.getDayMinimumeValue(this.mc_final_options_thu);
      //   this.totalPlannedNumber('thu');
      // } else if (day == 5) {
      //   this.sortArrays(this.mc_final_options_fri);
      //   // this.mc_daily_sum_prod_fri = this.$helpers.getDayMinimumeValue(this.mc_final_options_fri);
      //   this.totalPlannedNumber('fri');
      // } else if (day == 6) {
      //   this.sortArrays(this.mc_final_options_sat);
      //   // this.mc_daily_sum_prod_sat = this.$helpers.getDayMinimumeValue(this.mc_final_options_sat);
      //   this.totalPlannedNumber('sat');
      // } else if (day == 7) {
      //   this.sortArrays(this.mc_final_options_sun);
      //   // this.mc_daily_sum_prod_sun = this.$helpers.getDayMinimumeValue(this.mc_final_options_sun);
      //   this.totalPlannedNumber('sun');
      // }
    },

    showWarningHover(dayAvg, prod) {
      // console.log('showWarningHover', dayAvg, prod);
      let gline = this.guideline_data;
      // console.log('showWarningHover', dayAvg, prod, gline);
      let returnText = [];
      for (let i = 0; i < this.datas.length; i++) {
        let gValid = this.$helpers.checkGuildLineVals(gline[this.datas[i]['min']], gline[this.datas[i]['max']], parseFloat(dayAvg[this.datas[i]['name']]), this.datas[i]['type']);
        if (gValid == 'red') {
          if (this.datas[i]['name'] === 'sugar') {
            returnText.push('Total Sugar' + ': ' + this.$helpers.nearestValue(parseFloat(dayAvg[this.datas[i]['name']])) + ', Min: ' + this.$helpers.nearestValue(gline[this.datas[i]['min']]) + ', Max: ' + this.$helpers.nearestValue(gline[this.datas[i]['max']]));
          } else {
            returnText.push(this.datas[i]['name'] + ': ' + this.$helpers.nearestValue(parseFloat(dayAvg[this.datas[i]['name']])) + ', Min: ' + this.$helpers.nearestValue(gline[this.datas[i]['min']]) + ', Max: ' + this.$helpers.nearestValue(gline[this.datas[i]['max']]));
          }
          
        }
      }
      returnText = this.$helpers.getAdditionalProducts(gline, prod, returnText, 'daily');
      // console.log('showWarningHover1', returnText, dayAvg, prod);
      return returnText;
    },

    sortedArray: function (recipe_arrays) {
      // console.log("recipe_arrays", recipe_arrays);
      // return recipe_arrays;
      let a = _.orderBy(recipe_arrays, 'name', 'asc');
      a = _.orderBy(a, 'category_sort', 'asc');
      return a;
    },
    // changeMonthYearModalOpen() {
    //   this.changeMonthYearModal = true;
    // },
    changeDays() {
      let day_id = this.form.days_id;
      if (day_id != '') {
        let dd = this.days_data.find(x => x.id === day_id);
        // console.log('dd', dd);
        if (dd) {
          this.todal_days = dd.total_days;
        } else {
          this.todal_days = 0;
        }
      } else {
        this.todal_days = 0;
      }
    },

    // updateGuidelineValues() {
    //   if (this.form.meal_type_id && this.form.age_grade_id && this.form.days_id) {
    //     axios.post('/site-offering-get-guidelines', {
    //       meal_type: this.form.meal_type_id,
    //       age_range: this.form.age_grade_id,
    //       days: this.form.days_id,
    //     }).then((response) => {
    //       this.guidelines = response.data;
    //     })
    //       .catch(error => console.error(error));
    //   }


    // },

    sortArrays(arrays) {
      return arrays;
      return _.orderBy(arrays, 'sort', 'asc');
    },

    // getComponentTotalsAsPerOffering(e) {
    //   var guideline_id = e.target.value;
    //   axios.post('/get-component-limits-from-guideline', {
    //     guideline: guideline_id
    //   })
    //     .then((response) => {
    //       this.guideline_data = response.data;
    //     })
    //     .catch(error => console.error(error));
    // },

    addRecipeOptionMenuCycle(day) {
      this.addRecipesOptionModal = true;

      this.day_number = day;
      if (day == 1) {
        this.option_number = this.mc_final_options_mon.length + 1;
      }
      if (day == 2) {
        this.option_number = this.mc_final_options_tue.length + 1;
      }
      if (day == 3) {
        this.option_number = this.mc_final_options_wed.length + 1;
      }
      if (day == 4) {
        this.option_number = this.mc_final_options_thu.length + 1;
      }
      if (day == 5) {
        this.option_number = this.mc_final_options_fri.length + 1;
      }
      if (day == 6) {
        this.option_number = this.mc_final_options_sat.length + 1;
      }
      if (day == 7) {
        this.option_number = this.mc_final_options_sun.length + 1;
      }
      //console.log(this.mc_final_options_mon);
      this.name = "Option " + this.option_number;
    },

    closeOptionsModal(attachedRecipes, optionPhoto, dayNumber, optionNumber, name, is_favorite, assembly_serving_free_text, assembly_serving, assembly_serving_unit, assembly_instructions, is_exclude_from_export, a_la_carte) {
      console.log('closeOptionsModal');
      this.addRecipesOptionModal = false;
      console.log(attachedRecipes, optionPhoto, dayNumber, optionNumber);
      let total_val = {};

      if (attachedRecipes.length > 0) {
        total_val = this.$helpers.getRecipeTotal(attachedRecipes, this.$page.props.serve_logic);
        console.log("total_val", total_val);
      }

      let weeks = ['', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
      let day_of_week = weeks[dayNumber];
      console.log("day_of_week", day_of_week);

      let mc_options_final = {
        'recipes': attachedRecipes,
        'photo': optionPhoto,
        'sort': optionNumber,
        'name': name,
        'total_val': total_val,
        'is_favorite': is_favorite,
        'assembly_serving_free_text': assembly_serving_free_text,
        'assembly_serving': assembly_serving,
        'assembly_serving_unit': assembly_serving_unit,
        'assembly_instructions': assembly_instructions,
        'is_exclude_from_export': is_exclude_from_export,
        'a_la_carte': a_la_carte,
        'day_of_week': day_of_week,
        'planned_number': this.plannedNumber,
      };

      if (dayNumber == 1) {

        this.mc_final_options_mon.push(mc_options_final);
        // this.mc_daily_sum_prod_mon = this.$helpers.getDayMinimumeValue(this.mc_final_options_mon);
        //console.log(this.mc_final_options_mon);

        attachedRecipes.forEach((value, index) => {

          this.mc_recipes_mon[value['id']] = value;
          this.mc_recipe_prefer_prod_mon = value['prefer_products'];

          this.mc_daily_sum_prod_mon_all_data.push(this.mc_recipe_prefer_prod_mon);
          //  this.mc_daily_sum_prod_mon = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_mon_all_data);

          this.avg_products_weekly_all_data[0].push(this.mc_recipe_prefer_prod_mon);
          this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);

          this.mc_recipe_prefer_prod_mon = [];
        });
        this.totalPlannedNumber('mon');
      }
      if (dayNumber == 2) {

        this.mc_final_options_tue.push(mc_options_final);
        // this.mc_daily_sum_prod_tue = this.$helpers.getDayMinimumeValue(this.mc_final_options_tue);
        //console.log(this.mc_final_options_tue);

        attachedRecipes.forEach((value, index) => {
          this.mc_recipes_tue[value['id']] = value;
          this.mc_recipe_prefer_prod_tue = value['prefer_products'];

          this.mc_daily_sum_prod_tue_all_data.push(this.mc_recipe_prefer_prod_tue);
          // this.mc_daily_sum_prod_tue = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_tue_all_data);

          this.avg_products_weekly_all_data[1].push(this.mc_recipe_prefer_prod_tue);
          this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);

          this.mc_recipe_prefer_prod_tue = [];

        });
        this.totalPlannedNumber('tue');
      }
      if (dayNumber == 3) {

        this.mc_final_options_wed.push(mc_options_final);
        // this.mc_daily_sum_prod_wed = this.$helpers.getDayMinimumeValue(this.mc_final_options_wed);

        attachedRecipes.forEach((value, index) => {
          this.mc_recipes_wed[value['id']] = value;
          this.mc_recipe_prefer_prod_wed = value['prefer_products'];

          this.mc_daily_sum_prod_wed_all_data.push(this.mc_recipe_prefer_prod_wed);
          // this.mc_daily_sum_prod_wed = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_wed_all_data);

          this.avg_products_weekly_all_data[2].push(this.mc_recipe_prefer_prod_wed);
          this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);

          this.mc_recipe_prefer_prod_wed = [];
        });
        this.totalPlannedNumber('wed');
      }
      if (dayNumber == 4) {

        this.mc_final_options_thu.push(mc_options_final);
        // this.mc_daily_sum_prod_thu = this.$helpers.getDayMinimumeValue(this.mc_final_options_thu);

        attachedRecipes.forEach((value, index) => {
          this.mc_recipes_thu[value['id']] = value;
          this.mc_recipe_prefer_prod_thu = value['prefer_products'];

          this.mc_daily_sum_prod_thu_all_data.push(this.mc_recipe_prefer_prod_thu);
          // this.mc_daily_sum_prod_thu = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_thu_all_data);

          this.avg_products_weekly_all_data[3].push(this.mc_recipe_prefer_prod_thu);
          this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);

          this.mc_recipe_prefer_prod_thu = [];

        });
        this.totalPlannedNumber('thu');
      }
      if (dayNumber == 5) {

        this.mc_final_options_fri.push(mc_options_final);
        // this.mc_daily_sum_prod_fri = this.$helpers.getDayMinimumeValue(this.mc_final_options_fri);

        attachedRecipes.forEach((value, index) => {
          this.mc_recipes_fri[value['id']] = value;
          this.mc_recipe_prefer_prod_fri = value['prefer_products'];

          this.mc_daily_sum_prod_fri_all_data.push(this.mc_recipe_prefer_prod_fri);
          // this.mc_daily_sum_prod_fri = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_fri_all_data);

          this.avg_products_weekly_all_data[4].push(this.mc_recipe_prefer_prod_fri);
          this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);

          this.mc_recipe_prefer_prod_fri = [];

        });
        this.totalPlannedNumber('fri');
      }
      if (dayNumber == 6) {

        this.mc_final_options_sat.push(mc_options_final);
        // this.mc_daily_sum_prod_sat = this.$helpers.getDayMinimumeValue(this.mc_final_options_sat);

        attachedRecipes.forEach((value, index) => {
          this.mc_recipes_sat[value['id']] = value;
          this.mc_recipe_prefer_prod_sat = value['prefer_products'];

          this.mc_daily_sum_prod_sat_all_data.push(this.mc_recipe_prefer_prod_sat);
          // this.mc_daily_sum_prod_sat = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_sat_all_data);

          this.avg_products_weekly_all_data[5].push(this.mc_recipe_prefer_prod_sat);
          this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);

          this.mc_recipe_prefer_prod_sat = [];

        });
        this.totalPlannedNumber('sat');
      }
      if (dayNumber == 7) {

        this.mc_final_options_sun.push(mc_options_final);
        // this.mc_daily_sum_prod_sun = this.$helpers.getDayMinimumeValue(this.mc_final_options_sun);

        attachedRecipes.forEach((value, index) => {
          this.mc_recipes_sun[value['id']] = value;
          this.mc_recipe_prefer_prod_sun = value['prefer_products'];

          this.mc_daily_sum_prod_sun_all_data.push(this.mc_recipe_prefer_prod_sun);
          // this.mc_daily_sum_prod_sun = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_sun_all_data);

          this.avg_products_weekly_all_data[6].push(this.mc_recipe_prefer_prod_sun);
          this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);

          this.mc_recipe_prefer_prod_sun = [];

        });
        this.totalPlannedNumber('sun');
      }

    },

    addOptionEditScript(option_data, option_number, day) {
      this.addRecipesOptionModal = true;

      this.option_number = option_number + 1;
      this.day_number = day;

      //this.editOptionData = [];
      this.editOptionData = option_data;
      this.name = option_data.name;
      this.plannedNumber = option_data.planned_number;
    },

    addOptionCopyScript(option_data) {
      if (confirm("Are you sure you want to copy this option?")) {
        this.copied_option_data = this.convertOptionData(option_data);
      }
    },
    convertOptionData(option_data) {
      console.log("option_data 1", JSON.stringify(option_data));
      let od = JSON.stringify(option_data);
      od = JSON.parse(od);
      delete od["id"];
      delete od["menu_cycle_day_id"];
      delete od['menu_cycle_day_option_components'];
      if (od.recipes.length > 0) {
        od.recipes.map((oc) => {
          delete oc["option_component_id"];
          return oc;
        });
      }
      console.log("option_data 1", JSON.stringify(od));
      return od;
    },

    addOptionPasteScript(total, day) {
      if (this.copied_option_data != '') {
        if (confirm("Are you sure you want to paste here?")) {
          this.day_number = day;
          this.option_number = parseInt(total) + 1;
          this.closeOptionsModal(this.copied_option_data.recipes, this.copied_option_data.photo, day, this.option_number, this.copied_option_data.name);
        }
      } else {
        this.$toast.error('Error: Copy required first!');
      }

    },

    addOptionDuplicateScript(option_data, total, day) {
      if (confirm("Are you sure you want to duplicate this option?")) {
        let od = JSON.stringify(option_data);
        od = JSON.parse(od);
        delete od["id"];
        delete od["menu_cycle_day_id"];
        delete od['menu_cycle_day_option_components'];
        if (od.recipes.length > 0) {
          od.recipes.map((oc) => {
            delete oc["option_component_id"];
            return oc;
          });
        }
        option_data = od;
        // console.log("option_data 1", JSON.stringify(od));
        this.day_number = day;
        this.option_number = parseInt(total) + 1;

        this.closeOptionsModal(option_data.recipes, option_data.photo, day, this.option_number, option_data.name);
      }
    },

    addOptionDeleteScript(click_index, day) {
      let mc_option_id = "";
      if (confirm("Are you sure you want to delete this option?")) {
        if (day == 1) {
          mc_option_id = this.mc_final_options_mon[click_index].id;
          this.mc_final_options_mon.splice(click_index, 1);

          this.mc_daily_sum_prod_mon_all_data.splice(click_index, 1);
          // this.mc_daily_sum_prod_mon = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_mon_all_data);

          // this.mc_daily_sum_prod_mon = this.$helpers.getDayMinimumeValue(this.mc_final_options_mon);

          this.avg_products_weekly_all_data[0].splice(click_index, 1);
          this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);
          this.totalPlannedNumber('mon');
        }
        if (day == 2) {
          mc_option_id = this.mc_final_options_tue[click_index].id;
          this.mc_final_options_tue.splice(click_index, 1);

          this.mc_daily_sum_prod_tue_all_data.splice(click_index, 1);

          // this.mc_daily_sum_prod_tue = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_tue_all_data);

          // this.mc_daily_sum_prod_tue = this.$helpers.getDayMinimumeValue(this.mc_final_options_tue);

          this.avg_products_weekly_all_data[1].splice(click_index, 1);
          this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);
          this.totalPlannedNumber('tue');
        }
        if (day == 3) {
          mc_option_id = this.mc_final_options_wed[click_index].id;
          this.mc_final_options_wed.splice(click_index, 1);

          this.mc_daily_sum_prod_wed_all_data.splice(click_index, 1);
          // this.mc_daily_sum_prod_wed = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_wed_all_data);
          // this.mc_daily_sum_prod_wed = this.$helpers.getDayMinimumeValue(this.mc_final_options_wed);

          this.avg_products_weekly_all_data[2].splice(click_index, 1);
          this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);
          this.totalPlannedNumber('wed');
        }
        if (day == 4) {
          mc_option_id = this.mc_final_options_thu[click_index].id;
          this.mc_final_options_thu.splice(click_index, 1);

          this.mc_daily_sum_prod_thu_all_data.splice(click_index, 1);
          // this.mc_daily_sum_prod_thu = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_thu_all_data);

          // this.mc_daily_sum_prod_thu = this.$helpers.getDayMinimumeValue(this.mc_final_options_thu);

          this.avg_products_weekly_all_data[3].splice(click_index, 1);
          this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);
          this.totalPlannedNumber('thu');
        }
        if (day == 5) {
          mc_option_id = this.mc_final_options_fri[click_index].id;
          this.mc_final_options_fri.splice(click_index, 1);

          this.mc_daily_sum_prod_fri_all_data.splice(click_index, 1);
          // this.mc_daily_sum_prod_fri = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_fri_all_data);

          // this.mc_daily_sum_prod_fri = this.$helpers.getDayMinimumeValue(this.mc_final_options_fri);

          this.avg_products_weekly_all_data[4].splice(click_index, 1);
          this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);
          this.totalPlannedNumber('fri');

        }
        if (day == 6) {
          mc_option_id = this.mc_final_options_sat[click_index].id;
          this.mc_final_options_sat.splice(click_index, 1);

          this.mc_daily_sum_prod_sat_all_data.splice(click_index, 1);
          // this.mc_daily_sum_prod_sat = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_sat_all_data);

          // this.mc_daily_sum_prod_sat = this.$helpers.getDayMinimumeValue(this.mc_final_options_sat);

          this.avg_products_weekly_all_data[5].splice(click_index, 1);
          this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);
          this.totalPlannedNumber('sat');

        }
        if (day == 7) {
          mc_option_id = this.mc_final_options_sun[click_index].id;
          this.mc_final_options_sun.splice(click_index, 1);

          this.mc_daily_sum_prod_sun_all_data.splice(click_index, 1);
          // this.mc_daily_sum_prod_sun = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_sun_all_data);

          // this.mc_daily_sum_prod_sun = this.$helpers.getDayMinimumeValue(this.mc_final_options_sun);

          this.avg_products_weekly_all_data[6].splice(click_index, 1);
          this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);
          this.totalPlannedNumber('sun');

        }

        if (mc_option_id != "") {
          this.deleted_mc_option_ids.push(mc_option_id);
          console.log('deleted_mc_option_ids', this.deleted_mc_option_ids);
          this.form.post(this.route('menu-cycle-option-delete', mc_option_id), {
            onSuccess: () => {
              this.$toast.success('MenuCycle option deleted successfully!');
            }
          });
        }
      }

    },

    menucycle_edit_save_script() {
      this.mc_final_options_mon
      if (this.mc_final_options_mon.length > 0) {
        this.form.mc_options_mon = this.mc_final_options_mon;
      }
      if (this.mc_final_options_tue.length > 0) {
        this.form.mc_options_tue = this.mc_final_options_tue;
      }
      if (this.mc_final_options_wed.length > 0) {
        this.form.mc_options_wed = this.mc_final_options_wed;
      }
      if (this.mc_final_options_thu.length > 0) {
        this.form.mc_options_thu = this.mc_final_options_thu;
      }
      if (this.mc_final_options_fri.length > 0) {
        this.form.mc_options_fri = this.mc_final_options_fri;
      }
      if (this.mc_final_options_sat.length > 0) {
        this.form.mc_options_sat = this.mc_final_options_sat;
      }
      if (this.mc_final_options_sun.length > 0) {
        this.form.mc_options_sun = this.mc_final_options_sun;
      }
      this.form.is_template = 1;
      let newForm = this.form;


      const blob = new Blob([JSON.stringify(this.form)], { type: 'application/json' });

      blob.name = 'abc.json';
      // this.form.setError({ "mc_name": "This field is required." });
      // const blob = new Blob([this.form], { type: 'application/json', 'name': 'json.json' });
      console.log("JSON.stringify(this.form)", blob);
      let $this = this;
      document.getElementById('full_loader').style.display = "flex";
      Vapor.store(blob, {
        visibility: 'public-read',
        progress: (progress) => { },
      }).then((response) => {
        console.log("vapor response", response);
        $this.formNew.uuid = response.key;
        $this.formNew.mc_name = $this.form.mc_name;
        $this.formNew.meal_type_id = $this.form.meal_type_id;
        $this.formNew.age_grade_id = $this.form.age_grade_id;
        $this.formNew.days_id = $this.form.days_id;
        $this.formNew.guideline_id = $this.form.guideline_id;
        $this.formNew.post($this.route('menu-cycle-edit-save', $this.menucycle.id), {
          onError: (error) => {
            console.log('test error', error);
            // this.form.setErrors(error);
            $this.form.errors = error;
          },
          onSuccess: () => {
            $this.$toast.success('Menu Week has been Updated Successfully!');
          },
        });
      });
    },

    menucycle_cancel_script() {

      console.log('guide_line_id check', this.guide_line_id);

      console.log('deleted_mc_option_ids during cancel', this.deleted_mc_option_ids);

      axios.post('/menu-cycle-cancel-save', {
        deleted_mc_option_ids: this.deleted_mc_option_ids,
        deleted_option_component_ids: this.deleted_option_component_ids,
      })
        .then(response => {

          let redirectUrl = '';
          if (this.guide_line_id === '') {
            redirectUrl = this.route('week-cycles', {
              mealtype: this.mealtypeWeek,
              agerange: this.agerangeWeek,
              days: this.daysWeek,
              menuUser: this.menuUserWeek
            });
          } else {
            redirectUrl = this.$page.props.site_url + '/menu-planner' +
              '?month=' + this.month +
              '&year=' + this.year +
              '&type=' + this.form.type +
              '&site=' + this.form.site +
              '&guide_line_id=' + this.guide_line_id +
              '&offering_id=' + this.offering_id;
          }
          this.$inertia.visit(redirectUrl);
        })
        .catch(error => console.error(error));

    },

    removeById(arr, id) {
      // console.log('removeById', id);
      // console.log('removeById', String(id));
      const requiredIndex = arr.findIndex(el => {
        // console.log("el", id, el.id)
        return el.id === id;
      });
      // console.log('requiredIndex', requiredIndex);
      if (requiredIndex === -1) {
        return false;
      };
      // console.log('arr', arr);
      arr.splice(requiredIndex, 1);
      // console.log('arr', arr);
      return arr;
    },

    removeByOptionComponentId(arr, id) {
      // console.log('removeById', id);
      // console.log('removeById', String(id));
      const requiredIndex = arr.findIndex(el => {
        console.log("el", id, el.option_component_id);
        return el.option_component_id === id;
      });
      console.log('requiredIndex', requiredIndex);
      if (requiredIndex === -1) {
        return false;
      };
      console.log('arr', arr);
      arr.splice(requiredIndex, 1);
      console.log('arr', arr);
      return arr;
    },

    closeEditOptionsModal(attachedRecipes, optionPhoto, dayNumber, optionNumber, name = '', is_favorite, assembly_serving_free_text, assembly_serving, assembly_serving_unit, assembly_instructions, is_exclude_from_export, a_la_carte) {
      console.log("closeEditOptionsModal");
      this.addRecipesOptionModal = false;
      this.editOptionData = [];
      let index = optionNumber - 1;
      let total_val = {};

      console.log(attachedRecipes, optionPhoto, dayNumber, optionNumber);

      console.log("dayNumber", dayNumber);
      if (attachedRecipes.length > 0) {

        total_val = this.$helpers.getRecipeTotal(attachedRecipes, this.$page.props.serve_logic);
        console.log("total_val", total_val);
      }

      let weeks = ['', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
      let day_of_week = weeks[dayNumber];
      console.log("day_of_week", day_of_week);

      var mc_options_final = {
        'recipes': attachedRecipes,
        'photo': optionPhoto,
        'sort': optionNumber,
        'name': name,
        'total_val': total_val,
        'is_favorite': is_favorite,
        'planned_number': this.plannedNumber,
      };
      this.plannedNumber = 1;

      if (dayNumber == 1) {

        // this.mc_final_options_mon[index] = mc_options_final;

        this.mc_final_options_mon[index].recipes = attachedRecipes;
        this.mc_final_options_mon[index].photo = optionPhoto;
        this.mc_final_options_mon[index].sort = optionNumber;
        this.mc_final_options_mon[index].name = name;
        this.mc_final_options_mon[index].is_favorite = is_favorite;

        this.mc_final_options_mon[index].total_val = total_val;
        this.mc_final_options_mon[index].assembly_serving_free_text = assembly_serving_free_text;
        this.mc_final_options_mon[index].assembly_serving = assembly_serving;
        this.mc_final_options_mon[index].assembly_serving_unit = assembly_serving_unit;
        this.mc_final_options_mon[index].assembly_instructions = assembly_instructions;
        this.mc_final_options_mon[index].is_exclude_from_export = is_exclude_from_export;
        this.mc_final_options_mon[index].a_la_carte = a_la_carte;
        this.mc_final_options_mon[index].day_of_week = day_of_week;

        // this.mc_daily_sum_prod_mon = this.$helpers.getDayMinimumeValue(this.mc_final_options_mon);

        attachedRecipes.forEach((value, key) => {

          this.mc_recipes_mon[value['id']] = value;

          if (value['prefer_products']) {
            this.mc_recipe_prefer_prod_mon = value['prefer_products'];
            this.mc_daily_sum_prod_mon_all_data.push(this.mc_recipe_prefer_prod_mon);
            this.avg_products_weekly_all_data[0].push(this.mc_recipe_prefer_prod_mon);
          }

        });

        // this.mc_daily_sum_prod_mon = this.$helpers.getDayMinimumeValue(this.mc_final_options_mon);
        // this.mc_daily_sum_prod_mon = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_mon_all_data);

        this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);

        this.mc_recipe_prefer_prod_mon = [];

        this.totalPlannedNumber('mon');

      }
      if (dayNumber == 2) {

        // this.mc_final_options_tue[index] = mc_options_final;
        this.mc_final_options_tue[index].recipes = attachedRecipes;
        this.mc_final_options_tue[index].photo = optionPhoto;
        this.mc_final_options_tue[index].sort = optionNumber;
        this.mc_final_options_tue[index].name = name;
        this.mc_final_options_tue[index].total_val = total_val;
        this.mc_final_options_tue[index].is_favorite = is_favorite;
        this.mc_final_options_tue[index].assembly_serving_free_text = assembly_serving_free_text;
        this.mc_final_options_tue[index].assembly_serving = assembly_serving;
        this.mc_final_options_tue[index].assembly_serving_unit = assembly_serving_unit;
        this.mc_final_options_tue[index].assembly_instructions = assembly_instructions;
        this.mc_final_options_tue[index].is_exclude_from_export = is_exclude_from_export;
        this.mc_final_options_tue[index].a_la_carte = a_la_carte;
        this.mc_final_options_tue[index].day_of_week = day_of_week;

        // this.mc_daily_sum_prod_tue = this.$helpers.getDayMinimumeValue(this.mc_final_options_tue);

        attachedRecipes.forEach((value, key) => {

          this.mc_recipes_tue[value['id']] = value;

          if (value['prefer_products']) {
            this.mc_recipe_prefer_prod_tue = value['prefer_products'];
            this.mc_daily_sum_prod_tue_all_data.push(this.mc_recipe_prefer_prod_tue);
            this.avg_products_weekly_all_data[0].push(this.mc_recipe_prefer_prod_tue);
          }

        });

        // this.mc_daily_sum_prod_tue = this.$helpers.getDayMinimumeValue(this.mc_final_options_tue);
        // this.mc_daily_sum_prod_tue = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_tue_all_data);

        this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);

        this.mc_recipe_prefer_prod_tue = [];
        this.totalPlannedNumber('tue');
      }
      if (dayNumber == 3) {

        // this.mc_final_options_wed[index] = mc_options_final;

        this.mc_final_options_wed[index].recipes = attachedRecipes;
        this.mc_final_options_wed[index].photo = optionPhoto;
        this.mc_final_options_wed[index].sort = optionNumber;
        this.mc_final_options_wed[index].name = name;
        this.mc_final_options_wed[index].is_favorite = is_favorite;
        this.mc_final_options_wed[index].total_val = total_val;
        this.mc_final_options_wed[index].assembly_serving_free_text = assembly_serving_free_text;
        this.mc_final_options_wed[index].assembly_serving = assembly_serving;
        this.mc_final_options_wed[index].assembly_serving_unit = assembly_serving_unit;
        this.mc_final_options_wed[index].assembly_instructions = assembly_instructions;
        this.mc_final_options_wed[index].is_exclude_from_export = is_exclude_from_export;
        this.mc_final_options_wed[index].a_la_carte = a_la_carte;
        this.mc_final_options_wed[index].day_of_week = day_of_week;

        // this.mc_daily_sum_prod_wed = this.$helpers.getDayMinimumeValue(this.mc_final_options_wed);

        attachedRecipes.forEach((value, key) => {

          this.mc_recipes_wed[value['id']] = value;

          if (value['prefer_products']) {
            this.mc_recipe_prefer_prod_wed = value['prefer_products'];
            this.mc_daily_sum_prod_wed_all_data.push(this.mc_recipe_prefer_prod_wed);
            this.avg_products_weekly_all_data[0].push(this.mc_recipe_prefer_prod_wed);
          }

        });

        // this.mc_daily_sum_prod_wed = this.$helpers.getDayMinimumeValue(this.mc_final_options_wed);
        // this.mc_daily_sum_prod_wed = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_wed_all_data);

        this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);

        this.mc_recipe_prefer_prod_wed = [];
        this.totalPlannedNumber('wed');
      }
      if (dayNumber == 4) {

        this.mc_final_options_thu[index].recipes = attachedRecipes;
        this.mc_final_options_thu[index].photo = optionPhoto;
        this.mc_final_options_thu[index].sort = optionNumber;
        this.mc_final_options_thu[index].name = name;
        this.mc_final_options_thu[index].total_val = total_val;
        this.mc_final_options_thu[index].is_favorite = is_favorite;
        this.mc_final_options_thu[index].assembly_serving_free_text = assembly_serving_free_text;
        this.mc_final_options_thu[index].assembly_serving = assembly_serving;
        this.mc_final_options_thu[index].assembly_serving_unit = assembly_serving_unit;

        this.mc_final_options_thu[index].assembly_instructions = assembly_instructions;
        this.mc_final_options_thu[index].is_exclude_from_export = is_exclude_from_export;
        this.mc_final_options_thu[index].a_la_carte = a_la_carte;
        this.mc_final_options_thu[index].day_of_week = day_of_week;

        console.log("mc_final_options_thu", this.mc_final_options_thu);

        // this.mc_final_options_thu[index] = mc_options_final;
        // this.mc_daily_sum_prod_thu = this.$helpers.getDayMinimumeValue(this.mc_final_options_thu);

        attachedRecipes.forEach((value, key) => {

          this.mc_recipes_thu[value['id']] = value;

          if (value['prefer_products']) {
            this.mc_recipe_prefer_prod_thu = value['prefer_products'];
            this.mc_daily_sum_prod_thu_all_data.push(this.mc_recipe_prefer_prod_thu);
            this.avg_products_weekly_all_data[0].push(this.mc_recipe_prefer_prod_thu);
          }

        });

        // this.mc_daily_sum_prod_thu = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_thu_all_data);

        this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);

        this.mc_recipe_prefer_prod_thu = [];
        this.totalPlannedNumber('thu');
      }
      if (dayNumber == 5) {

        // this.mc_final_options_fri[index] = mc_options_final;

        this.mc_final_options_fri[index].recipes = attachedRecipes;
        this.mc_final_options_fri[index].photo = optionPhoto;
        this.mc_final_options_fri[index].sort = optionNumber;
        this.mc_final_options_fri[index].name = name;
        this.mc_final_options_fri[index].total_val = total_val;
        this.mc_final_options_fri[index].is_favorite = is_favorite;
        this.mc_final_options_fri[index].assembly_serving_free_text = assembly_serving_free_text;
        this.mc_final_options_fri[index].assembly_serving = assembly_serving;
        this.mc_final_options_fri[index].assembly_serving_unit = assembly_serving_unit;

        this.mc_final_options_fri[index].assembly_instructions = assembly_instructions;
        this.mc_final_options_fri[index].is_exclude_from_export = is_exclude_from_export;
        this.mc_final_options_fri[index].a_la_carte = a_la_carte;
        this.mc_final_options_fri[index].day_of_week = day_of_week;

        // this.mc_daily_sum_prod_fri = this.$helpers.getDayMinimumeValue(this.mc_final_options_fri);

        attachedRecipes.forEach((value, key) => {

          this.mc_recipes_fri[value['id']] = value;

          if (value['prefer_products']) {
            this.mc_recipe_prefer_prod_fri = value['prefer_products'];
            this.mc_daily_sum_prod_fri_all_data.push(this.mc_recipe_prefer_prod_fri);
            this.avg_products_weekly_all_data[0].push(this.mc_recipe_prefer_prod_fri);
          }

        });

        // this.mc_daily_sum_prod_fri = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_fri_all_data);

        this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);

        this.mc_recipe_prefer_prod_fri = [];
        this.totalPlannedNumber('fri');
      }
      if (dayNumber == 6) {

        this.mc_final_options_sat[index].recipes = attachedRecipes;
        this.mc_final_options_sat[index].photo = optionPhoto;
        this.mc_final_options_sat[index].sort = optionNumber;
        this.mc_final_options_sat[index].name = name;
        this.mc_final_options_sat[index].total_val = total_val;
        this.mc_final_options_sat[index].is_favorite = is_favorite;
        this.mc_final_options_sat[index].assembly_serving_free_text = assembly_serving_free_text;
        this.mc_final_options_sat[index].assembly_serving = assembly_serving;
        this.mc_final_options_sat[index].assembly_serving_unit = assembly_serving_unit;

        this.mc_final_options_sat[index].assembly_instructions = assembly_instructions;
        this.mc_final_options_sat[index].is_exclude_from_export = is_exclude_from_export;
        this.mc_final_options_sat[index].a_la_carte = a_la_carte;
        this.mc_final_options_sat[index].day_of_week = day_of_week;
        // this.mc_final_options_sat[index] = mc_options_final;
        // this.mc_daily_sum_prod_sat = this.$helpers.getDayMinimumeValue(this.mc_final_options_sat);

        attachedRecipes.forEach((value, key) => {

          this.mc_recipes_sat[value['id']] = value;

          if (value['prefer_products']) {
            this.mc_recipe_prefer_prod_sat = value['prefer_products'];
            this.mc_daily_sum_prod_sat_all_data.push(this.mc_recipe_prefer_prod_sat);
            this.avg_products_weekly_all_data[0].push(this.mc_recipe_prefer_prod_sat);
          }

        });

        // this.mc_daily_sum_prod_sat = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_sat_all_data);

        this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);

        this.mc_recipe_prefer_prod_sat = [];
        this.totalPlannedNumber('sat');
      }
      if (dayNumber == 7) {

        this.mc_final_options_sun[index].recipes = attachedRecipes;
        this.mc_final_options_sun[index].photo = optionPhoto;
        this.mc_final_options_sun[index].sort = optionNumber;
        this.mc_final_options_sun[index].name = name;
        this.mc_final_options_sun[index].total_val = total_val;
        this.mc_final_options_sun[index].is_favorite = is_favorite;
        this.mc_final_options_sun[index].assembly_serving_free_text = assembly_serving_free_text;
        this.mc_final_options_sun[index].assembly_serving = assembly_serving;
        this.mc_final_options_sun[index].assembly_serving_unit = assembly_serving_unit;

        this.mc_final_options_sun[index].assembly_instructions = assembly_instructions;
        this.mc_final_options_sun[index].is_exclude_from_export = is_exclude_from_export;
        this.mc_final_options_sun[index].a_la_carte = a_la_carte;
        this.mc_final_options_sun[index].day_of_week = day_of_week;

        // this.mc_final_options_sun[index] = mc_options_final;
        // this.mc_daily_sum_prod_sun = this.$helpers.getDayMinimumeValue(this.mc_final_options_sun);

        attachedRecipes.forEach((value, key) => {

          this.mc_recipes_sun[value['id']] = value;

          if (value['prefer_products']) {
            this.mc_recipe_prefer_prod_sun = value['prefer_products'];
            this.mc_daily_sum_prod_sun_all_data.push(this.mc_recipe_prefer_prod_sun);
            this.avg_products_weekly_all_data[0].push(this.mc_recipe_prefer_prod_sun);
          }

        });

        // this.mc_daily_sum_prod_sun = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_sun_all_data);

        this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);

        this.mc_recipe_prefer_prod_sun = [];
        this.totalPlannedNumber('sun');
      }

    },
    deleteOptionRecipeButton(recipeObj, element, dayName) {
      console.log(recipeObj, element.recipes, 'this is recipeObj');
      if (confirm("Are you sure you want to delete this?")) {
        let $this = this;

        if (recipeObj.option_component_id) {
          // console.log(
          //   "recipeObj.option_component_id",
          //   recipeObj.option_component_id
          // );
          axios
          .post("/menu-cycle-option-recipe-delete/id/" +
              recipeObj.option_component_id)
          .catch((error) => console.error(error));
          // Inertia.post(
          //   "/menu-cycle-option-recipe-delete/id/" +
          //   recipeObj.option_component_id,
          //   {},
          //   {
          //     onSuccess: () => {
                element.recipes = element.recipes.filter(
                  (recipe) => recipe.id !== recipeObj.id
                );

                element.recipes.forEach((value, index) => {
                  $this[`mc_recipes_${dayName}`][value['id']] = value;
                  $this[`mc_recipe_prefer_prod_${dayName}`] = value['prefer_products'];

                  $this[`mc_daily_sum_prod_${dayName}_all_data`].push($this[`mc_recipe_prefer_prod_${dayName}`]);
                  //  this.mc_daily_sum_prod_mon = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_mon_all_data);

                  $this.avg_products_weekly_all_data[0].push(this[`mc_recipe_prefer_prod_${dayName}`]);
                  $this.mc_weekly_avg_prods = $this.$helpers.avg_products_week_setup($this.avg_products_weekly_all_data);

                  $this[`mc_recipe_prefer_prod_${dayName}`] = [];
                });

                $this.totalPlannedNumber(dayName);
          //     }
          //   }
          // );
        }
      }
    },

    replaceOptionRecipe(recipe, recipeIndex, elementArray, indexKey, dayName) {
      console.log('pop up model called', recipe);

      this.selectedRecipe = recipe;
      this.optionReplacePopup = true;
      this.optionReplaceArray = {
        elementArray: elementArray,
        indexKey: indexKey,
        dayName: dayName,
        recipe: recipe,
        recipeIndex: recipeIndex
      };
    },

    closeOptionReplacePopup() {
      this.optionReplacePopup = false;
      this.selectedRecipe = null;
      this.optionReplaceArray = null;
    },
    makeReplaceRecipe1(newRecipe, is_whole_week) {

      console.log('newRecipe', newRecipe, is_whole_week);
      console.log("optionReplaceArray", this.optionReplaceArray);
      let { recipeIndex, indexKey, dayName, recipe } = this.optionReplaceArray;

      // elementArray  = null;


      if (this.optionReplaceArray) {
        if (is_whole_week) {
          this.replaceOptionRecipeWeek(newRecipe, recipe);
        } else {
          // Sort recipes and replace the recipe at the specified index
          // elementArray.recipes = this.sortedArray(elementArray.recipes);
          let elementArray = JSON.parse(JSON.stringify(this.optionReplaceArray.elementArray));
          console.log('elementArray.recipes', recipeIndex, elementArray.recipes[recipeIndex]);
          elementArray.recipes = this.sortedArray(elementArray.recipes);
          newRecipe.option_component_id = elementArray.recipes[recipeIndex].option_component_id;
          elementArray.recipes[recipeIndex] = newRecipe;
          if (newRecipe.option_component_id) {
            elementArray.menu_cycle_day_option_components.forEach((value, index) => {
              if (value.id == newRecipe.option_component_id) {
                value.recipe_id = newRecipe.id;
              }
              elementArray.menu_cycle_day_option_components[index] = value;
            });
          }


          // Update the final options for the specific day
          this[`mc_final_options_${dayName}`][indexKey] = elementArray;
          // this.mc_final_options_mon[indexKey] = elementArray;

          elementArray.recipes.forEach((value, index) => {
            this[`mc_recipes_${dayName}`][value['id']] = value;
            this[`mc_recipe_prefer_prod_${dayName}`] = value['prefer_products'];

            this[`mc_daily_sum_prod_${dayName}_all_data`].push(this[`mc_recipe_prefer_prod_${dayName}`]);
            //  this.mc_daily_sum_prod_mon = this.$helpers.sum_products_daily_setup(this.mc_daily_sum_prod_mon_all_data);

            this.avg_products_weekly_all_data[0].push(this[`mc_recipe_prefer_prod_${dayName}`]);
            this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);

            this[`mc_recipe_prefer_prod_${dayName}`] = [];
          });
          this.totalPlannedNumber(dayName);
        }

      }
    },
    replaceOptionRecipeWeek(newRecipe, replaceableRecipe1) {
      let days = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
      console.log("replaceOptionRecipeWeek in");

      days.forEach(day => {
        if (this[`mc_final_options_${day}`] && Object.keys(this[`mc_final_options_${day}`]).length > 0) {
          console.log("replaceOptionRecipeWeek", day, this[`mc_final_options_${day}`]);
          this[`mc_final_options_${day}`].forEach((dayData, index) => {
            if (dayData.recipes.length > 0) {
              console.log("replaceOptionRecipeWeek dayData final 1", dayData.recipes, dayData.menu_cycle_day_option_components);
              dayData.recipes.forEach((recipe, recipeIndex) => {
                let replaceableRecipe = replaceableRecipe1;
                console.log("replaceOptionRecipeWeek dayData if", recipe.id == replaceableRecipe.id, recipe.id, replaceableRecipe.id);

                if (recipe.id == replaceableRecipe.id) {
                  newRecipe.option_component_id = recipe.option_component_id;
                  // console.log("replaceOptionRecipeWeek", day, recipe, newRecipe);
                  dayData.recipes[recipeIndex] = newRecipe;

                  console.log("replaceOptionRecipeWeek dayData if new", recipe.id == replaceableRecipe.id, recipe.id, replaceableRecipe.option_component_id);

                  if (newRecipe.option_component_id) {
                    dayData.menu_cycle_day_option_components.forEach((value, index) => {
                      if (value.id == newRecipe.option_component_id) {
                        value.recipe_id = newRecipe.id;
                        console.log("replaceOption RecipeWeek dayData change", day, value);
                      }
                      console.log("replaceOption RecipeWeek dayData", day, dayData);
                      dayData.menu_cycle_day_option_components[index] = value;
                      console.log("replaceOptionRecipeWeek dayData change", day, dayData);
                    });
                  }
                  console.log("replaceOptionRecipeWeek dayData", day, dayData);
                }

              });

              console.log("replaceOptionRecipeWeek dayData final 2", dayData.recipes, dayData.menu_cycle_day_option_components);
              this[`mc_final_options_${day}`][index] = dayData;

              dayData.recipes.forEach((value, index) => {
                this[`mc_recipes_${day}`][value['id']] = value;
                this[`mc_recipe_prefer_prod_${day}`] = value['prefer_products'];

                this[`mc_daily_sum_prod_${day}_all_data`].push(this[`mc_recipe_prefer_prod_${day}`]);

                this.avg_products_weekly_all_data[0].push(this[`mc_recipe_prefer_prod_${day}`]);
                this.mc_weekly_avg_prods = this.$helpers.avg_products_week_setup(this.avg_products_weekly_all_data);

                this[`mc_recipe_prefer_prod_${day}`] = [];
              });
              this.totalPlannedNumber(day);
            }
          });
        }
      });
    },
    resetList() {

      this.mc_final_options_mon = JSON.parse(JSON.stringify(this.mc_final_options_mon1));
      this.mc_final_options_tue = JSON.parse(JSON.stringify(this.mc_final_options_tue1));
      this.mc_final_options_wed = JSON.parse(JSON.stringify(this.mc_final_options_wed1));
      this.mc_final_options_thu = JSON.parse(JSON.stringify(this.mc_final_options_thu1));
      this.mc_final_options_fri = JSON.parse(JSON.stringify(this.mc_final_options_fri1));
      this.mc_final_options_sat = JSON.parse(JSON.stringify(this.mc_final_options_sat1));
      this.mc_final_options_sun = JSON.parse(JSON.stringify(this.mc_final_options_sun1));
      this.mc_daily_sum_prod_mon = JSON.parse(JSON.stringify(this.mc_daily_sum_prod_mon1));
      this.mc_daily_sum_prod_tue = JSON.parse(JSON.stringify(this.mc_daily_sum_prod_tue1));
      this.mc_daily_sum_prod_wed = JSON.parse(JSON.stringify(this.mc_daily_sum_prod_wed1));
      this.mc_daily_sum_prod_thu = JSON.parse(JSON.stringify(this.mc_daily_sum_prod_thu1));
      this.mc_daily_sum_prod_fri = JSON.parse(JSON.stringify(this.mc_daily_sum_prod_fri1));
      this.mc_daily_sum_prod_sat = JSON.parse(JSON.stringify(this.mc_daily_sum_prod_sat1));
      this.mc_daily_sum_prod_sun = JSON.parse(JSON.stringify(this.mc_daily_sum_prod_sun1));
      this.mc_weekly_avg_prods = JSON.parse(JSON.stringify(this.mc_weekly_avg_prods1));
      this.changeDays();

    }
  },


};
</script>
<style>
.preview-popup .xl\:px-10 {
  padding-left: 0;
  padding-right: 0;
}
</style>